'use client';

import { RadialGradientBG } from '@jouzen/ecom-components/v3/GradientBG';

import landingPageBodyGradients from '@/app/components/LandingPage/_data/landingPageBodyGradients/landingPageBodyGradients';
import useScrollTracking from '@/app/hooks/useScrollTracking';

import WomensHealthArticles from './_components/WomensHealthArticles/WomensHealthArticles';
import WomensHealthFeatures from './_components/WomensHealthFeatures/WomensHealthFeatures';
import WomensHealthHero from './_components/WomensHealthHero/WomensHealthHero';
import WomensHealthIntegrations from './_components/WomensHealthIntegrations/WomensHealthIntegrations';
import WomensHealthJumbotron from './_components/WomensHealthJumbotron/WomensHealthJumbotron';
import WomensHealthTestimony from './_components/WomensHealthTestimonials/WomensHealthTestimonials';

const Content = () => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return (
    <div data-cy="womens-health-page">
      <WomensHealthHero />
      <RadialGradientBG
        background="sandstone-200"
        className="overflow-hidden"
        gradients={landingPageBodyGradients}
      >
        <div className="relative">
          <WomensHealthFeatures />
          <WomensHealthJumbotron />
          <WomensHealthTestimony />
          <WomensHealthIntegrations />
          <WomensHealthArticles />
        </div>
      </RadialGradientBG>
    </div>
  );
};

export default Content;
